//Handle sharing
var FwWebsite = window.FwWebsite || {};

FwWebsite.Social = {
    settings: {
        source: 'okologisknorge.no',
        siteName: 'Økologisk Norge',
        twitterProfile: ''
    },

    init: function (options) {
        var $ = jQuery,
            me = this;

        me.winWidth = 600;
        me.winHeight = 580;
        me.winTop = screen.height / 2 - me.winHeight / 2;
        me.winLeft = screen.width / 2 - me.winWidth / 2;

        FwWebsite.Social.settings = $.extend(FwWebsite.Social.settings, options);
    },

    doFacebookShare: function (url, title, intro, image) {
        if (FB) {
            //Required FB SDK and AppID
            FB.ui({
                method: 'share',
                href: '' + url + '',
                caption: '' + title + '',
                description: '' + intro + '',
                picture: '' + image + ''
            }, function (response) { });
        } else {
            alert('Sharing to facebook requires FB SDK and a registered App.');
        }
    },

    doTwitterShare: function (url, title, windowTitle) {
        if (!windowTitle)
        {
            windowTitle = 'Del på Twitter';
        }
        var twitVia = '';
        if (FwWebsite.Social.settings.twitterProfile) {
            twitVia = '&amp;via=' + FwWebsite.Social.settings.twitterProfile;
        }
        window.open('https://twitter.com/intent/tweet?url=' + url + '&amp;text=' + title + twitVia, windowTitle, 'top=' + this.winTop + ',left=' + this.winLeft + ',toolbar=0,status=0,width=' + this.winWidth + ',height=' + this.winHeight);
    },

    doGooglePlusShare: function (url, windowTitle) {
        if (!windowTitle) {
            windowTitle = 'Del på Google+';
        }
        window.open('https://plus.google.com/share?url=' + url, windowTitle, 'top=' + this.winTop + ',left=' + this.winLeft + ',toolbar=0,status=0,width=' + this.winWidth + ',height=' + this.winHeight);
    },

    doLinkedinShare: function (url, title, windowTitle) {
        if (!windowTitle) {
            windowTitle = 'Del på LinkedIn';
        }
        window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title + '&summary=&source=' + FwWebsite.Social.settings.source, windowTitle, 'top=' + this.winTop + ',left=' + this.winLeft + ',toolbar=0,status=0,width=' + this.winWidth + ',height=' + this.winHeight);
    }
};

//initialize the sharing buttons API
window.FwWebsite.Social.init({});